export default "__VITE_PUBLIC_ASSET__c46ca089__"